import { Card } from "app/shadcnComponents/ui/card";
import { cn } from "app/lib/utils";
import ChatAvatar from "app/components/Chat/ChatAvatar";
import ChatMarkdown from "./ChatMarkdown";

interface Props {
  readonly type: "user" | "assistant";
  readonly message: string;
  readonly isPrivate?: boolean;
}

export default function MessageBubble({ type, message, isPrivate }: Props) {
  if (type === "assistant") {
    return (
      <div className="flex items-end">
        <ChatAvatar isPrivate={isPrivate} />
        <Card
          className={cn(
            "bg-white rounded-tl-[20px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[2px]",
            "px-3 py-2",
            "border-0 w-full",
            "shadow-message",
            "font-['Lato'] text-[14px] font-normal leading-5 text-[#001f4e]"
          )}
        >
          <ChatMarkdown>{message}</ChatMarkdown>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex justify-end">
      <Card
        className={cn(
          "!bg-[#687dd2] rounded-tl-[20px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[2px]",
          "px-3 py-2 flex flex-col items-end",
          "border-none w-fit",
          "shadow-message",
          "font-['Lato'] text-[14px] font-normal leading-5 !text-white"
        )}
      >
        <ChatMarkdown>{message}</ChatMarkdown>
      </Card>
    </div>
  );
}
